import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Row,
} from "reactstrap";

import ModalLoding from "../../Components/Common/ModalLoading";

import * as Yup from "yup";
import states from "../../utils/states.json";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import Modal from "../../Components/Common/Modal";

import UiContent from "../../Components/Common/UiContent";
import {
  CoverUploadImageField,
  InputMask,
  TextField,
} from "../../Components/Forms";
import LazyImage from "../../Components/LazyImage/LazyImage";

import PlaceMenu from "../../Components/Places/PlaceMenu";
import { getCitiesRequest } from "../../store/city/actions";
import {
  deleteTouristReceptionPhotoRequest,
  getTouristReceptionRequest,
  updateTouristReceptionPhotoRequest,
  updateTouristReceptionRequest,
} from "../../store/touristReceptions/actions";
import { isLatitude, isLongitude } from "../../utils/formats";
import { api } from "../../boot/api";
import showNofity from "../../helpers/toast";
import { Checkbox } from "../../Components/Forms/Checkbox";
import { forceNumericCoordinate } from "../../utils/coordinates";

const TouristReceptionFormEdit = () => {
  document.title = "Turismo receptivo | Ecoguias - Admin Dashboard";

  const MANDATORY_FIELD = "Este campo é obrigatório";

  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();

  const { data, loading } = useSelector((state) => state.TouristReception);
  const { data: dataCity, loading: loadingCity } = useSelector(
    (state) => state.City
  );

  const [legendImage, setLegendImage] = useState([]);

  const [modalIsOpenRemove, setModalIsOpenRemove] = useState(false);
  const [modalIsOpenSelect, setModalIsOpenSelect] = useState(false);
  const [photoId, setPhotoId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    dispatch(getTouristReceptionRequest(id));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(getCitiesRequest());
  }, [dispatch]);

  const tourismExists = data?.result?.receptionTourist;
  const tourismResponse = data?.result?.receptionTourist;

  const touristReception = useFormik({
    enableReinitialize: true,

    initialValues: {
      nome: tourismExists ? tourismResponse?.nome : "",
      email: tourismExists ? tourismResponse?.email : "",
      url_site: tourismExists ? tourismResponse?.url_site : "",
      descritivo: tourismExists ? tourismResponse?.descritivo : "",
      url_video: tourismExists ? tourismResponse?.url_video : "",
      telefones: tourismExists ? tourismResponse?.telefones : "",
      images: tourismExists ? tourismResponse?.images : [],
      latitude: tourismExists ? tourismResponse?.gps?.latitude : "",
      longitude: tourismExists ? tourismResponse?.gps?.longitude : "",
      cidade: tourismExists ? tourismResponse?.cidade?.objectId : "",
      estado: tourismExists ? tourismResponse?.estado : "",
      logradouro: tourismExists ? tourismResponse?.logradouro : "",
      numero: tourismExists ? tourismResponse?.numero : "",
      bairro: tourismExists ? tourismResponse?.bairro : "",
      whatsapp: tourismExists ? tourismResponse?.whatsapp : "",
      instagram: tourismExists ? tourismResponse?.instagram : "",
      patrocinado: tourismExists ? tourismResponse?.patrocinado : false,
    },

    validationSchema: Yup.object({
      nome: Yup.string().required(MANDATORY_FIELD),
      email: Yup.string(),
      url_site: Yup.string().nullable().optional(),
      descritivo: Yup.string().required(MANDATORY_FIELD),
      images: Yup.array(Yup.string()),
      url_video: Yup.string().nullable().optional(),
      telefones: Yup.string(),
      cidade: Yup.string().required(MANDATORY_FIELD),
      estado: Yup.string(),
      logradouro: Yup.string(),
      numero: Yup.string(),
      bairro: Yup.string(),
      whatsapp: Yup.string().nullable().optional(),
      instagram: Yup.string().nullable().optional(),
      latitude: Yup.string()
        .nullable()
        .test("is-latitude", "Insira uma latitude válida", (value) =>
          value ? isLatitude(value) : true
        ),
      longitude: Yup.string()
        .nullable()
        .test("is-longitude", "Insira uma longitude válida", (value) =>
          value ? isLongitude(value) : true
        ),
      patrocinado: Yup.boolean(),
    }),

    onSubmit: async (values) => {
      values.latitude = forceNumericCoordinate(values.latitude);
      values.longitude = forceNumericCoordinate(values.longitude);

      dispatch(
        updateTouristReceptionRequest({
          id: id,
          values,
          onSuccess: () => touristReception.setFieldValue("images", []),
        })
      );
    },
  });

  function addLegendInState(index, txt) {
    const copyLegend = [...legendImage];
    copyLegend[index] = txt;

    setLegendImage(copyLegend);
  }

  async function updateLegend(imagemId, legenda) {
    try {
      await api.post("/photo-tourism-reception-update-legend-admin", {
        imagemId,
        legenda,
      });
      showNofity.success("Legenda salva com sucesso");
    } catch (error) {
      showNofity.error("Erro ao salvar legenda");
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Editar turismo receptivo"
            pageTitle="Turismo receptivo"
          />
        </Container>

        <Col lg={12}>
          <Card>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>

            <CardBody>
              <div className="live-preview">
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    touristReception.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <Row className="g-3">
                    <CoverUploadImageField
                      title="Adicionar imagens"
                      multiple
                      data={touristReception}
                      name="images"
                      isActiveRadioSelect={false}
                    />

                    <TextField
                      label="Nome"
                      name="nome"
                      data={touristReception}
                    />

                    <TextField
                      label="Email"
                      name="email"
                      data={touristReception}
                    />

                    <TextField
                      label="Url do site"
                      name="url_site"
                      data={touristReception}
                    />

                    <TextField
                      label="Url do vídeo"
                      name="url_video"
                      data={touristReception}
                    />

                    <InputMask
                      type="phone-br"
                      label="Telefone"
                      name="telefones"
                      data={touristReception}
                      size={3}
                    />

                    <InputMask
                      type="phone-br"
                      label="Whatsapp"
                      name="whatsapp"
                      data={touristReception}
                      size={3}
                    />

                    <TextField
                      label="Instagram"
                      name="instagram"
                      data={touristReception}
                    />

                    <TextField
                      label="Logradouro"
                      name="logradouro"
                      data={touristReception}
                    />

                    <TextField
                      label="Número"
                      name="numero"
                      data={touristReception}
                      size={2}
                    />

                    <TextField
                      label="Cidade"
                      name="cidade"
                      type="select"
                      data={touristReception}
                      size={4}
                    >
                      <option value="" disabled selected>
                        Selecione uma cidade
                      </option>
                      {dataCity?.result?.length > 0 &&
                        dataCity?.result.map((item, index) => (
                          <option key={index} value={item.objectId}>
                            {item.nome}
                          </option>
                        ))}
                    </TextField>

                    <TextField
                      label="Estado"
                      name="estado"
                      type="select"
                      data={touristReception}
                      size={2}
                    >
                      <option value="" disabled selected>
                        Selecione um estado
                      </option>

                      {states.map(({ sigla, id_uf }) => (
                        <option key={id_uf} value={sigla}>
                          {sigla}
                        </option>
                      ))}
                    </TextField>

                    <TextField
                      label="Bairro"
                      name="bairro"
                      data={touristReception}
                    />

                    <TextField
                      label="Latitude"
                      name="latitude"
                      data={touristReception}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                      size={2}
                    />
                    <TextField
                      label="Longitude"
                      name="longitude"
                      data={touristReception}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                      size={2}
                    />

                    <TextField
                      label="Descrição"
                      name="descritivo"
                      type="textarea"
                      data={touristReception}
                      size={12}
                    />

                    <Checkbox
                      label="Estabelecimento patrocinado"
                      name="patrocinado"
                      data={touristReception}
                    />

                    {data?.result?.images?.length > 0 && (
                      <>
                        <h3>Imagens do local</h3>
                        <p>
                          Escolha uma opção abaixo para excluir uma imagem ou
                          selecionar a imagem principal do local
                        </p>
                      </>
                    )}

                    {id && (
                      <React.Fragment>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 10,
                          }}
                        >
                          {data?.result?.images?.map((item, idx) => {
                            return item.imagem?.name ? (
                              <div>
                                <Col key={idx} lg={3} style={styles.imageList}>
                                  {item.imagem.url !==
                                  data?.result?.receptionTourist?.imagem
                                    ?.url ? (
                                    <PlaceMenu
                                      remove={() => {
                                        setPhotoId(item.objectId);
                                        setModalIsOpenRemove(true);
                                      }}
                                      select={() => {
                                        setSelectedImage(item?.imagem);
                                        setModalIsOpenSelect(true);
                                      }}
                                    />
                                  ) : null}
                                  <LazyImage
                                    src={item?.imagem?.url}
                                    width="100%"
                                    height="100%"
                                    className="object-fit-cover rounded"
                                    style={
                                      item.imagem.url ===
                                      data?.result?.receptionTourist?.imagem.url
                                        ? styles.lazyImage
                                        : null
                                    }
                                  />
                                </Col>
                                <div style={{ marginTop: 10 }}></div>
                                <InputGroup>
                                  <Input
                                    value={item.legenda}
                                    title="Legenda"
                                    name="Legenda"
                                    placeholder="Legenda"
                                    size="sm"
                                    className="form-control"
                                    onChange={(event) =>
                                      addLegendInState(idx, event.target.value)
                                    }
                                  />
                                  <Button
                                    size="sm"
                                    className="primary"
                                    onClick={() =>
                                      updateLegend(
                                        item.objectId,
                                        legendImage[idx]
                                      )
                                    }
                                  >
                                    <i className="ri-save-2-line fs-13"></i>
                                  </Button>
                                </InputGroup>
                              </div>
                            ) : null;
                          })}
                        </div>
                      </React.Fragment>
                    )}

                    <Col lg={12}>
                      <div className="text-end">
                        <button type="submit" className="btn btn-primary">
                          Enviar
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </CardBody>
          </Card>
        </Col>
      </div>

      <Modal
        isOpen={modalIsOpenRemove}
        text="Tem certeza que deseja remover essa imagem?"
        onClick={() => {
          dispatch(
            deleteTouristReceptionPhotoRequest({
              touristReceptionId: id,
              photoId: photoId,
            })
          );

          setModalIsOpenRemove(false);
        }}
        onCancel={() => {
          setModalIsOpenRemove(false);
        }}
      />

      <Modal
        isOpen={modalIsOpenSelect}
        text="Tem certeza que deseja selecionar essa imagem como a principal deste receptivo turístico?"
        onClick={() => {
          dispatch(
            updateTouristReceptionPhotoRequest({
              touristReceptionId: id,
              imagem: selectedImage,
            })
          );

          setModalIsOpenSelect(false);
        }}
        onCancel={() => {
          setModalIsOpenSelect(false);
        }}
      />
      <ModalLoding loading={loading} />
    </React.Fragment>
  );
};

const styles = {
  lazyImage: {
    borderColor: "#93bf85",
    borderWidth: 5,
    borderStyle: "solid",
    borderRadius: 10,
  },
  imageList: {
    display: "flex",
    position: "relative",
    height: 220,
    width: 260,
  },
};

export default TouristReceptionFormEdit;
